import GridBlock from "components/GridBlock";
import Tr from "translations/Translations";
import SimpleSelect from "components/SimpleSelect";
import AuditTaskStatus from "../constants/AuditTaskStatus";
import React from "react";
import PropTypes from "prop-types";
import {TextField, withStyles} from "@material-ui/core";
import DateFormats from "constants/DateFormats";
import {KeyboardDateTimePicker} from "@material-ui/pickers";
import WorkableIconButton from "components/button/WorkableIconButton";
import SearchIcon from "@material-ui/icons/Search";
import IconButton from "components/button/IconButton";
import ClearIcon from "@material-ui/icons/Clear";

const style = theme => ({
    root: {
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(1)
    },
    spaceRight: {
        marginRight: theme.spacing(4),
    },
    search: {
        width: 400,
    },
    chipsGrid: {
        marginTop: theme.spacing(1)
    },
    user: {
        width: 250,
    },
    select: {
        width: 150,
    },
    date: {
        width: 190,
    }
})

function AuditListSearchBar({
    classes,
    adminMode,
    filters,
    setFilters,
    onSubmit,
    onReset,
    searching
}) {

    const handleKeyUp = (e) => {
        if (e.key === 'Enter') {
            onSubmit();
        }
    }

    return (
        <>
            <GridBlock
                alignItems='flex-end'
                className={classes.root}
                itemClassName={classes.spaceRight}
            >
                <TextField
                    className={classes.search}
                    label={Tr('audit_task_name')}
                    onChange={e => setFilters({...filters, name: e.target.value})}
                    onKeyUp={handleKeyUp}
                    value={filters.name}
                    fullWidth

                />
                {adminMode && <TextField
                    className={classes.user}
                    label={Tr('user')}
                    onChange={e => setFilters({...filters, user: e.target.value})}
                    onKeyUp={handleKeyUp}
                    value={filters.user}
                    fullWidth

                />}
                <KeyboardDateTimePicker
                    className={classes.date}
                    label={Tr('audit_task_date_start')}
                    ampm={false}
                    format={DateFormats.DATETIME_FORMAT}
                    variant='dialog'
                    cancelLabel={Tr('cancel')}
                    value={filters.dateStart}
                    invalidDateMessage={Tr("invalid_date_format")}
                    onChange={e => setFilters({...filters, dateStart: (e ? e : null)})}
                />
                <KeyboardDateTimePicker
                    className={classes.date}
                    label={Tr('audit_task_date_end')}
                    ampm={false}
                    format={DateFormats.DATETIME_FORMAT}
                    variant='dialog'
                    cancelLabel={Tr('cancel')}
                    value={filters.dateEnd}
                    invalidDateMessage={Tr("invalid_date_format")}
                    onChange={e => setFilters({...filters, dateEnd: (e ? e : null)})}
                />
                <SimpleSelect
                    label={Tr('status')}
                    className={classes.select}
                    items={AuditTaskStatus}
                    onChange={(e) => setFilters({...filters, status: e.target.value})}
                    value={filters.status}
                />
                <div>
                    <WorkableIconButton Icon={SearchIcon} working={searching} onClick={onSubmit} tooltip={Tr('search')}/>
                    <IconButton disabled={searching} Icon={ClearIcon} tooltip={Tr('clear')} onClick={onReset}/>
                </div>
            </GridBlock>
        </>
    )
}

AuditListSearchBar.propTypes = {
    classes: PropTypes.any,
}

AuditListSearchBar.defaultProps = {}

export default withStyles(style)(AuditListSearchBar);